import { Paragraph, Table, TableRow, TableCell } from "docx";
import { formatFloats } from "./published-model-helpers";

export const createModelResultsHeaderRow = () => {
  return new TableRow({
    children: [
      new TableCell({ children: [new Paragraph("")] }),
      new TableCell({ children: [new Paragraph("Est. Enrollment")] }),
      new TableCell({ children: [new Paragraph("Est. Institutional Aid")] }),
      new TableCell({ children: [new Paragraph("Est. Net Revenue")] }),
      new TableCell({ children: [new Paragraph("Est. Discount Rate")] }),
    ],
  });
};

export const createModelResultsDataRow = (modelResults) => {
  return new TableRow({
    children: [
      new TableCell({ children: [new Paragraph("New Projected Model")] }),
      new TableCell({
        children: [new Paragraph(formatFloats(modelResults.estEnrollment))],
      }),
      new TableCell({
        children: [
          new Paragraph(
            formatFloats(modelResults.estInstitutionalAid, "currency")
          ),
        ],
      }),
      new TableCell({
        children: [
          new Paragraph(formatFloats(modelResults.estNetRevenue, "currency")),
        ],
      }),
      new TableCell({
        children: [
          new Paragraph(formatFloats(modelResults.estDiscountRate, "percent")),
        ],
      }),
    ],
  });
};

export const createFirstYearEstimateDataRow = (firstYearEstimate) => {
  return new TableRow({
    children: [
      new TableCell({ children: [new Paragraph("First Year Estimate")] }),
      new TableCell({
        children: [
          new Paragraph(formatFloats(firstYearEstimate.estEnrollment)),
        ],
      }),
      new TableCell({
        children: [
          new Paragraph(
            formatFloats(firstYearEstimate.estInstitutionalAid, "currency")
          ),
        ],
      }),
      new TableCell({
        children: [
          new Paragraph(
            formatFloats(firstYearEstimate.estNetRevenue, "currency")
          ),
        ],
      }),
      new TableCell({
        children: [
          new Paragraph(
            formatFloats(firstYearEstimate.estTuitionDiscountRate, "percent")
          ),
        ],
      }),
    ],
  });
};

export const createNonModeledDataRows = (nonModeledData) => {
  return nonModeledData.map((item) => {
    return new TableRow({
      children: [
        new TableCell({ children: [new Paragraph(item.group)] }),
        new TableCell({
          children: [new Paragraph(formatFloats(item.estEnrollment))],
        }),
        new TableCell({
          children: [
            new Paragraph(formatFloats(item.estInstitutionalAid, "currency")),
          ],
        }),
        new TableCell({
          children: [
            new Paragraph(formatFloats(item.estNetRevenue, "currency")),
          ],
        }),
        new TableCell({
          children: [
            new Paragraph(
              formatFloats(item.estTuitionDiscountRate / 100, "percent")
            ),
          ],
        }),
      ],
    });
  });
};

export const createNonModeledDataTable = (
  modelResults,
  firstYearEstimate,
  nonModeledData
) => {
  const headerRow = createModelResultsHeaderRow();
  const modelResultsRow = createModelResultsDataRow(modelResults);
  const nonModeledDataRows = createNonModeledDataRows(nonModeledData);
  const firstYearEstimateRow =
    createFirstYearEstimateDataRow(firstYearEstimate);

  return new Table({
    rows: [
      headerRow,
      modelResultsRow,
      ...nonModeledDataRows,
      firstYearEstimateRow,
    ],
  });
};
